/**
 * The hover card of a value's marker: which containers keep their own
 * value of this section, with the value when it fits in a few words
 * ("TEST 2 · 802 SMS"), and what Override does.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';
import type { DropGenSection } from '@trafficpulse/shared';

import { SECTION_LABEL } from '../../../../campaign/master/rule-facts';
import { ownValueWords, type PushOwner } from '../push-owners';

interface Props {
  section: DropGenSection;
  owners: PushOwner[];
  masterName: string;
}

export const OwnersCard: FC<Props> = ({ section, owners, masterName }) => (
  <span className="flex flex-col gap-2">
    <span className="text-[10px] font-semibold uppercase tracking-wider text-muted-foreground">Own {SECTION_LABEL[section]}</span>
    <span className="grid grid-cols-[auto_auto] gap-x-6 gap-y-1">
      {owners.map(({ container: c }) => {
        const value = ownValueWords(c, section);
        return (
          <span key={c.id} className="contents">
            <span className="truncate font-medium">{c.name}</span>
            <span className={value ? 'text-right tabular-nums' : 'text-right text-muted-foreground'}>{value ?? 'its own'}</span>
          </span>
        );
      })}
    </span>
    <span className="border-t border-border pt-2 text-muted-foreground">Override gives them {masterName}’s.</span>
  </span>
);
